<template>
    <div class="articles__inner">
        <h2 class="articles__headline">{{ dictionary.ArticlesHeadline }}</h2>
        <ul class="filter">
            <li class="filter__item" v-if="tags.length > 0">
                <label for="tagFilter" class="sr-only">{{
                    dictionary.ArticlesTagSelectLabel
                }}</label>
                <select id="tagFilter" v-model="tag" :disabled="isLoading">
                    <option value="All">{{ dictionary.ArticlesTagSelectLabel }}</option>
                    <option v-for="tagItem in tags" :key="tagItem.Key" :value="tagItem.Key">{{
                        tagItem.Name
                    }}</option>
                </select>
            </li>
            <li class="filter__item" v-if="products.length > 0">
                <label for="productFilter" class="sr-only">{{ dictionary.ArticlesProductSelectLabel }}</label>
                <select id="productFilter" v-model="product" :disabled="isLoading">
                    <option value="All">{{ dictionary.ArticlesProductSelectLabel }}</option>
                    <option v-for="productItem in products" :key="productItem.Key" :value="productItem.Key">{{
                        productItem.Name
                    }}
                    </option>
                </select>
            </li>
        </ul>
        <div class="filter__item" v-if="hasFilterApplied">
            <button type="button" @click="tag = defaultTag" v-if="this.tag != 'All'">{{ tags.find(x=> x.Key == tag)?.Name }}</button>
            <button type="button" @click="product = defaultProduct" v-if="this.product != 'All'">{{ products.find(x=> x.Key == product)?.Name }}</button>
            <button type="button" @click="resetFilters">{{ dictionary.ArticlesResetFilter }}</button>
        </div>
        <ul class="articles__list">
            <li class="articles__list-item" v-for="project in articles" :key="project.Url">
                <a :href="project.Url">
                    <div class="articles__list-image">
                        <ResponsiveImage v-if="project.ImageForVue != null" :imageModel="project.ImageForVue" />
                    </div>
                    <div class="articles__list-info">
                        <div class="article-item__headline">
                            {{ project.Title }}
                        </div>
                        <div v-if="project.HasText" class="articles__list-text">
                            {{ project.Text }}
                        </div>
                        <div class="articles__list-link">{{ dictionary.ArticlesReadStory }}</div>
                    </div>
                </a>
            </li>
        </ul>
        <div class="articles__footer">
            <div class="articles__no-articles" v-show="!articles.length && !isLoading">
                {{ dictionary.ArticlesNoResults }}
            </div>
            <div class="articles__load-more" v-show="hasMoreArticles">
                <a @click="getNextPage" :disabled="isLoading">{{
                    dictionary.ArticlesLoadMore
                }}</a>
            </div>
        </div>
    </div>
</template>

<script>
import { bindRoute } from "./mixins/bindroute.js";
import ResponsiveImage from "./components/responsiveImage.vue";

const serviceUrl = "/umbraco/api/articlesapi/getarticles",
    defaultTag = "All",
    defaultProduct = "All";
export default {
    name: "articles",
    components: {
        ResponsiveImage
    },
    data() {
        return {
            dictionary: [],
            tags: [],
            products: [],
            articles: [],
            pageSize: 9,
            page: 1,
            totalArticles: 0,
            isLoading: false,
            hasLoadedInitials: false,
            articlesNodeId: 0,
            isResetting: false
        };
    },
    mixins: [
        bindRoute({
            tag: defaultTag,
            product: defaultProduct
        }),
    ],
    watch: {
        tag: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        product: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        }
    },
    mounted() {
        this.articlesNodeId = this.$parent.articlesNodeId;
        this.pageSize = this.$parent.pageSize;

        this.$router.isReady().then(() => {
            this.getInitialArticles();
        }).catch(error => {
            console.log(error);
        });
    },
    methods: {
        handleFilterPropertyChange(oldVal, newVal) {
            if (oldVal !== newVal) {
                if (this.hasLoadedInitials && !this.isResetting) {
                    this.filterChanged();
                }
            }
        },
        getArticles(amountToSkip, pageSize) {
            const vm = this,
                languageCode = document.querySelector("html").getAttribute("lang");
            vm.toggleSpinner(true);
            var object = {
                articlesNodeId: vm.articlesNodeId,
                languageCode: languageCode,
                amountToSkip: amountToSkip,
                pageSize: pageSize,
            };

            if (vm.tag != defaultTag) {
                object.tag = vm.tag;
            }
            if (vm.product != defaultProduct) {
                object.product = vm.product;
            }

            fetch(serviceUrl + "?" + new URLSearchParams(object))
                .then((response) => response.json())
                .then((data) => {
                    vm.dictionary = data.Dictionaries;
                    vm.tags = data.Facets.tags;
                    vm.products = data.Facets.products;
                    vm.articles.push(...data.Items);
                    vm.totalArticles = data.TotalItems;
                    vm.hasLoadedInitials = true;
                    vm.toggleSpinner(false);
                    vm.isResetting = false;
                })
                .catch((error) => {
                    console.log(error);
                    vm.toggleSpinner(false);
                });
        },
        getNextPage() {
            if (!this.isLoading) {
                this.page++;
                this.getArticles(this.pageSize * (this.page - 1), this.pageSize);
            }
        },
        getInitialArticles() {
            // Get all cases up to, and including, the current page
            const initialPageSize = this.pageSize * this.page;
            this.getArticles(0, initialPageSize);
        },
        filterChanged() {
            this.articles = [];
            this.totalArticles = 0;
            this.page = 1;
            this.getArticles(0, this.pageSize);
        },
        resetFilter() {
            const vm = this;
            vm.isResetting = true;
            vm.articles = [];
            vm.totalArticles = 0;
            vm.page = 1;
            vm.tag = defaultTag;
            vm.product = defaultProduct;

            vm.$router.replace({ path: window.location.pathname, query: {} })
                .then(() => {
                    vm.getArticles(0, vm.pageSize);
                })
                .catch(err => { console.log(err); });
        },
        resetFilters() {
            const vm = this;
            vm.isResetting = true;
            vm.articles = [];
            vm.totalArticles = 0;
            vm.page = 1;
            vm.tag = defaultTag;
            vm.product = defaultProduct;

            vm.$router.replace({ path: window.location.pathname, query: {} })
                .then(() => {
                    vm.getArticles(0, vm.pageSize);
                })
                .catch(err => { console.log(err); });
        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;
            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        },
    },
    computed: {
        hasMoreArticles() {
            return (
                this.totalArticles !== 0 &&
                this.articles.length < this.totalArticles
            );
        },
        hasFilterApplied() {
            return this.tag != defaultTag ||
                this.product != defaultProduct;
        }
    },
};
</script>